import { RecordDrawDisbursementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateRecordDrawDisbursement = makeValidator({
  FieldParser: RecordDrawDisbursementRow,
});
